<template>
    <b-col cols="12" class="mt-4 text-center terms-disclosure">
        <span class="agree">
            By clicking {{button}}, you agree to our
            <a class="agree-links" :href="Constants.TERMS_CONDITIONS_URL" target="_blank">Terms</a>
            and have read and acknowledge our
            <a class="agree-links" :href="Constants.PRIVACY_POLICY_URL" target="_blank">US Privacy Statement.</a>
        </span>
        <br>
        <span v-if="showDate" class="last-updated">Updated on January 1, 2020</span>
    </b-col>
</template>

<script>
    import {Constants} from '@/core/Utils'
    export default {
        name: "LegalWarning",
        props: {
            button: {
                type: String,
                required: true
            },
            showDate: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                Constants: Constants
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import "~@/core/Styles/variables.styl"

    .terms-disclosure
        line-height 1.2

    .agree
        font-family arial, sans-serif
        font-size 12px
        font-style italic

    .agree-links
        font-family arial, sans-serif
        font-size 12px
        font-style italic
        color color-5

    .last-updated
        font-family arial, sans-serif
        font-size 12px
        font-weight bold
        font-style italic
        color black
</style>